import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import Modal from 'uikit/Modal';
import CourseTypes from 'components/Course/Shared/CourseTypes';

import styles from './CourseMethod.module.scss';

const cx = classNames.bind(styles);

const CourseMethod = ({ handleMethodUpdate, t }) => (
  <Modal isOpen>
    <div className={cx('modal')}>
      <h1 className={cx('title')}>{t('Course/Teacher/CourseMethod/title')}</h1>
      <CourseTypes display="small" handleTypeUpdate={handleMethodUpdate} />
      <p className={cx('info')}>{t('Course/Teacher/CourseMethod/info')}</p>
    </div>
  </Modal>
);

CourseMethod.propTypes = {
  handleMethodUpdate: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default CourseMethod;
